export default __webpack_public_path__ + "static/media/Consultoria-Informatica-PT.ff597281.jpg";